function getRussianNumberEnding(number) {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return 'ов';
    }

    switch (lastDigit) {
        case 1:
            return '';
        case 2:
        case 3:
        case 4:
            return 'а';
        default:
            return 'ов';
    }
}

export function getCompletedLessonLabel(number) {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return "пройденных";
    }

    if (lastDigit === 1) {
        return "пройденный";
    }

    return "пройденных";
}

export function getRussianNumberEndingFemaleGenetive(number) {
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return 'ок';
    }

    switch (lastDigit) {
        case 1:
            return 'ка';
        case 2:
        case 3:
        case 4:
            return 'ки';
        default:
            return 'ок';
    }
}

export default getRussianNumberEnding;